import constants from './constants';
import createScheduleConst from './../create_schedule/constants';
import pickupSlotConst from './../pickup_slot/constants';
import { getSanitizedSchedule } from './utils';

const initialState = {
    activeDateSlot: null,
    schedule: {},
    address: null,
}

const removeProp = (key, obj) => {
    const newObj = {};
    for (let k in obj) {
        if (k === key) continue;
        newObj[k] = obj[k];
    }
    return newObj;
}

const addProp = (key, obj) => {
    const newObj = {};
    //newObj[key] = [];
    if (Object.keys(obj).length <= 0) {
        newObj[key] = [];
    }
    else {

    }
    for (let k in obj) {
        if (k === key) continue;
        newObj[k] = obj[k];
    }
    return newObj;
}

const getNewSchedule = (schedule, data) => {
    let newSchedule = {};
    if (!data.isMulti) {
        newSchedule = Object.keys(schedule).reduce((acc, cur) => {
            return { ...acc, [cur]: [] }
        }, {})
    } else {
        newSchedule = { ...schedule };
    }

    return {
        ...newSchedule,
        [data.activeDay]: data.slots
    }
}

const scheduler = (state = initialState, action) => {
    switch (action.type) {
        case constants.SET_ACTIVE_DAY_SLOT:
            return { ...state, activeDateSlot: action.data }
        case constants.TOGGLE_DAY:
            return {
                ...state,
                //schedule: state.schedule[action.data]
                //    ? removeProp(action.data, state.schedule)
                //    : addProp(action.data, state.schedule),
                //activeDateSlot: state.activeDateSlot === action.data
                //    ? null
                //    : state.activeDateSlot
               
                schedule: state.schedule[action.data]
                    ? removeProp(action.data, state.schedule)
                    : { ...state.schedule, [action.data]: [] },
                activeDateSlot: state.activeDateSlot === action.data
                    //? null
                    //? state.activeDateSlot
                    //: action.data
                    ? Object.keys(state.schedule).length > 1 ? (Object.keys(state.schedule)[Object.keys(state.schedule).length - 1] == state.activeDateSlot ? Object.keys(state.schedule)[Object.keys(state.schedule).length - 2] : state.activeDateSlot) : state.activeDateSlot
                    : (state.schedule[action.data] === undefined) ? action.data : state.activeDateSlot
            }
        case constants.TOGGLE_SLOT:
            return {
                ...state,
                schedule: getNewSchedule(state.schedule, action.data)
            }

        case `${createScheduleConst.GET_SCHEDULE}_ENDED`: {
            const scheduleJSON = action.data.data.buyerSchedules || action.data.data.schedules;
            const { addressName } = (action.data.data.address || {});

            const address = addressName ? action.data.data.address : null;
            return {
                ...state,
                address,
                schedule: getSanitizedSchedule(scheduleJSON, !!action.data.data.buyerSchedules)
            }
        }
        case `${constants.RESCHEDULE_EVENT}_ENDED`:
            const scheduleJSON = action.data.data.buyerSchedules || action.data.data.schedules;
            const { addressName } = (action.data.data.address || {});

            const address = addressName ? action.data.data.address : null;
            return {
                ...state,
                address,
                schedule: getSanitizedSchedule(scheduleJSON, !!action.data.data.buyerSchedules)
            }
            //const {
            //    name: eventName,
            //    schedules: schedulesJSON,
            //    ...rest
            //} = action.data.data;

            //const schedules = getSanitizedSchedule(schedulesJSON);

            //return {
            //    ...state,
            //    isSuccesMessageVisible: false,
            //    pending: false,
            //    eventName,
            //    schedules: schedules,
            //    ...rest
            //}

        case `${pickupSlotConst.GET_PICKUP_DATA}_ENDED`: {
            const { addressName } = (action.data.data.address || {});

            const address = addressName ? action.data.data.address : null;

            return {
                ...state,
                address,
                schedule: getSanitizedSchedule(action.data.data.schedules, true)
            }
        }
        case `${pickupSlotConst.SEND_PICKUP_DATA}_ENDED`: {
            return {
                ...state,
                activeDateSlot : null,
                schedule: getSanitizedSchedule(action.data.data.schedules, true)
            }
        }
        case constants.SET_ADDRESS:
            return { ...state, address: action.data }

        case constants.RESET_SCHEDULER_STATE:
            return { ...state, activeDateSlot: null, schedule: {} };

        default:
            return state;
    }
}

export default scheduler